import { useHeaderHeight } from "../../hooks/useHeaderHeight";
import Utils from "../../utils/utils";
import BookingCard from "./BookingCard";

export const BookingBox = () => {
  const { headerHeight } = useHeaderHeight();
  return (
    <div className="hidden min-w-[21.25rem] sm:block">
      <div
        style={{ top: headerHeight + Utils.remToPx(5) }}
        className="sticky mb-[2rem]"
      >
        <BookingCard />
      </div>
    </div>
  );
};
